import styles from './index.module.less';
import { Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { isApp } from '@/utils/common';
import { bybitHecate } from '@web3/base-utils';
import { appPath } from '@web3/base-utils';
import { useParams } from '@web3/base-hooks';
// import DropGiftRotate from '@/assets/images/bybitsol/drop-gift-rotate.png';

export const StakingNow = ({ activity }) => {
  const fm = useFm();
  const { locale } = useParams();

  const handleClick = () => {
    if (isApp()) {
      bybitHecate('Router', 'push', {
        path: 'bybitapp://open/route?targetUrl=by-mini://web3_applet/earn/stake/sol_lst',
      });
    } else {
      const webUrl = `${origin}/${locale}${appPath}/BybitSOL`;
      const appUrl = `bybitapp://open/route?targetUrl=${encodeURIComponent('by-mini://web3_applet/earn/stake/sol_lst')}`;
      const link = `https://app.bybit.com/inapp?by_dp=${encodeURIComponent(appUrl)}&by_web_link=${encodeURIComponent(webUrl)}&force_redirect=true`;
      window.top?.open(link);
    }
  };
  //
  const onHoldButtonClick = () => {
    handleClick();
  };
  //
  return (
    <div className={`${styles.container} flex-col gap-4`}>
      <Button
        className={styles.button}
        variant="primary"
        size="large"
        onClick={handleClick}
      >
        {fm('stakeNow1')}
      </Button>

      {activity && (
        <Button
          className={`${styles['btn-hold']} relative`}
          onClick={onHoldButtonClick}
        >
          <span className={styles['btn-hold-text']}>
            {fm('holdBbSOL', {
              tokenSymbol: activity?.rewardTokenDetail?.symbol,
            })}
          </span>
          {/* <img
            src={DropGiftRotate.src}
            alt="drop-gift"
            className="h-12 absolute right-0 -top-5"
          /> */}
        </Button>
      )}
    </div>
  );
};
